// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration of possible children types that can be rendered into a layout column
 */
export enum ChildrenTypes {
    /**
     * A Fast DNA ActionTrigger component
     */
    actionTrigger = "ActionTrigger",
    /**
     * A Fast DNA Button component
     */
    button = "Button",

    /**
     * A Fast DNA Heading component
     */
    heading = "Heading",

    /**
     * A React Peregrine Experience
     */
    peregrineExperience = "PeregrineExperience",

    /**
     * A Fast DNA Typography component
     */
    typography = "Typography",

    /**
     * A Web Component Experience
     */
    webComponentExperience = "WebComponentExperience"
}